import { render } from "./S311443.vue?vue&type=template&id=f9de0186"
const script = {}
script.render = render

export default script